<template>
  <div class="raft-file-upload-row">
    <span
      >{{ attachedFile.name
      }}<b-button :disabled="disableRemoval" @click="removeFile(attachedFile)">
        Remove</b-button
      ></span
    >
  </div>
</template>

<script>
export default {
  name: "RaftFileUploadRow",
  components: {},
  props: {
    attachedFile: {
      type: File,
      required: true,
    },
    disableRemoval: { type: Boolean, default: false },
  },
  data() {
    return {};
  },
  computed: {},
  methods: {
    deleteRow(event) {
      console.log({ event });
    },
    removeFile(removedFile) {
      this.$emit("fileRemove", removedFile, removedFile.name);
    },
  },
};
</script>

<style scoped>
.raft-file-upload-row {
  display: flex;
  justify-content: space-between;
  width: 100%;
  font-size: 0.8rem;
  font-weight: 400;
  font-family:
    -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial,
    sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol";
  color: #304458;
}
.full-screen-icon {
  right: 20px;
  height: 16px;
  position: absolute;
}
</style>
